export default __webpack_public_path__ + "static/media/blank_image.2fda6558.png";